import React from 'react'

const Services = () => {
  return (
    <div>
            <h1>gal</h1>
    </div>
  )
}

export default Services
